import { List, Record } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';

import BaseStore from './BaseStore';

export const TocOnlyAvailability = new Record({
    origin: null,
    destination: null,
    result: null
});

export class TocOnlyStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.CHECK_TOC_ONLY_ADD]: this.handleNewStations
        };
    }

    getInitialState () {
        return new List();
    }

    handleNewStations ({ search, result }) {
        const origin = search.origin.nlc;
        const destination = search.destination.nlc;
        this.setState(
            this.state.push(
                new TocOnlyAvailability({
                    origin,
                    destination,
                    result
                }))
        );
    }

    handleExistingStations () {
        this.emitChange();
    }

    getAvailability (search) {
        return this.state.find((entry) => {
            if (entry.origin === search.origin.nlc && entry.destination === search.destination.nlc) {
                return true;
            }
            return false;
        });
    }
}

export default new TocOnlyStore();



// WEBPACK FOOTER //
// ./src/stores/TocOnlyStore.js